import React, { useTransition } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperComponent from "../common/swipers";
import { Grid, Pagination } from "swiper";
const OoredooAdd = ({ pmsitem }) => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const {
        data: { data } = {},
        isLoading,
        isFetching,
        isSuccess,
        isError
    } = useQuery(["", pmsitem.method, JSON.parse(pmsitem.sourceid), {}, false],
        {
            retry: false,
            retryOnMount: false,
            cacheTime: 0,
            staleTime: 0
        })
    const navigateItem = (url) => {
        if (url === "addonshome") {
            navigate('/addonshome');
        }
        else if (url === "bundleshome") {
            navigate('/bundles');
        } else if (url === "digitalservicehome") {
            navigate('/digitalservices');
        }
        else if (url === "roaminghome") {
            navigate('/passportmulticountry');
        }
    }

    if (isSuccess) {
        if (data != null && data != undefined && data != "" && data?.status == "0") {
            //alert(JSON.stringify(data));
            console.log("ooredoo add data:" + JSON.stringify(data))
        }
    }

    if(!data?.response || data?.response?.length === 0){
        return <></>
    }

    return (
        <div class="mb-3 dls-sprint13-comp dls-sprint13-ooredooadd">
            <div class="flex_grp_between mb-3">
                <h3 class="section_title_light mb-0">{pmsitem?.metadata?.title}</h3>
                {
                    pmsitem?.metadata?.show_viewall === "true" && pmsitem?.metadata?.more_title && (
                        <a class="hyperlink" target='_blank' href={pmsitem?.metadata?.more_url}>
                            {pmsitem?.metadata?.more_title}
                            <img src={process.env.PUBLIC_URL + '/assets/images/right_arrow_red.svg'} alt="" title="" />
                        </a>
                    )
                }
            </div>
            <div class="mt-4">
                <div class="dls13_card_style3 mb-2 gap-3">
                <SwiperComponent type={21} data={data}></SwiperComponent>
                </div>
            </div>

        </div>
    )
}

export default OoredooAdd;
